export let InvoiceDigestStatus = /*#__PURE__*/function (InvoiceDigestStatus) {
  InvoiceDigestStatus["RequiresClientApproval"] = "requiresClientApproval";
  InvoiceDigestStatus["PaymentsVerificationRequired"] = "paymentsVerificationRequired";
  InvoiceDigestStatus["MissingPaymentMethod"] = "missingPaymentMethod";
  InvoiceDigestStatus["Failed"] = "failed";
  InvoiceDigestStatus["Disputed"] = "disputed";
  InvoiceDigestStatus["PaymentStopped"] = "paymentStopped";
  return InvoiceDigestStatus;
}({});